var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "arrow-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.237 8.38787C11.1615 8.31238 11.1016 8.22276 11.0608 8.12413C11.0199 8.02549 10.9989 7.91978 10.9989 7.81302C10.9989 7.70626 11.0199 7.60055 11.0608 7.50192C11.1016 7.40329 11.1615 7.31367 11.237 7.23818C11.3125 7.16269 11.4021 7.10281 11.5008 7.06195C11.5994 7.0211 11.7051 7.00007 11.8119 7.00007C11.9186 7.00007 12.0243 7.0211 12.123 7.06195C12.2216 7.10281 12.3112 7.16269 12.3867 7.23818L20.5117 15.3632C20.5872 15.4386 20.6472 15.5282 20.6881 15.6269C20.729 15.7255 20.75 15.8312 20.75 15.938C20.75 16.0448 20.729 16.1505 20.6881 16.2492C20.6472 16.3478 20.5872 16.4374 20.5117 16.5129L12.3867 24.6379C12.2342 24.7903 12.0275 24.876 11.8119 24.876C11.5963 24.876 11.3895 24.7903 11.237 24.6379C11.0846 24.4854 10.9989 24.2786 10.9989 24.063C10.9989 23.8474 11.0846 23.6406 11.237 23.4882L18.7882 15.938L11.237 8.38787Z",
    fill: "#909090"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.f4d345a2345779365341eee2b1471032.svg";
export { ForwardRef as ReactComponent };